module.exports = __webpack_public_path__ + "static/media/playlist.11a6707b.svg";